import styled from '@emotion/styled'

import { SkeletonBox } from '../SkeletonBox'

export const SkeletonCircle = styled(SkeletonBox)`
  flex-shrink: 0;
  border-radius: 50%;
`
